module.exports = __webpack_public_path__ + "img/banner-loading-3.7d66f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/project/loader/banner-loading-3.jpg
// module id = W1Xa
// module chunks = 9